module.exports = __webpack_public_path__ + "static/media/publication_new.ba47d146.png";